export default __webpack_public_path__ + "static/media/quiz_floating.937b96b2.svg";